export default "__VITE_ASSET__BAE8bnI0__"